import { CLEAR_GRAPH_DATA, GET_COMPLETION_ANALYSIS_DATA_FAIL, GET_COMPLETION_ANALYSIS_DATA_REQUEST, GET_COMPLETION_ANALYSIS_DATA_SUCCESS, GET_EXIT_ANALYSIS_DATA_FAIL, GET_EXIT_ANALYSIS_DATA_REQUEST, GET_EXIT_ANALYSIS_DATA_SUCCESS, GET_LEADS_DATA_FAIL, GET_LEADS_DATA_REQUEST, GET_LEADS_DATA_SUCCESS, GET_QUESTION_WISE_ANALYSIS_DATA_FAIL, GET_QUESTION_WISE_ANALYSIS_DATA_REQUEST, GET_QUESTION_WISE_ANALYSIS_DATA_SUCCESS, GET_SURVEYS_FAIL, GET_SURVEYS_REQUEST, GET_SURVEYS_SUCCESS } from "../constant"

const initialState = {
  completionData: {},
  questionWiseAnalysis: [],
  exitAnalysis: [],
  surveyData: [],
  leadsData: [],
}

const analyticsReducer = (state = initialState, action) => {
  switch (action.type) {

    //Get completion analysis 
    case GET_COMPLETION_ANALYSIS_DATA_REQUEST:
      return {
        ...state,
        completionData: {}
      }
    case GET_COMPLETION_ANALYSIS_DATA_SUCCESS:
      return {
        ...state,
        completionData: action.payload
      }
    case GET_COMPLETION_ANALYSIS_DATA_FAIL:
      return {
        ...state,
        completionData: {}
      }

    //Get surveys
    case GET_SURVEYS_REQUEST:
      return {
        ...state,
        surveyData: []
      }
    case GET_SURVEYS_SUCCESS:
      return {
        ...state,
        surveyData: action.payload
      }
    case GET_SURVEYS_FAIL:
      return {
        ...state,
        surveyData: []
      }

    //Get question wise analysis 
    case GET_QUESTION_WISE_ANALYSIS_DATA_REQUEST:
      return {
        ...state,
        questionWiseAnalysis: []
      }
    case GET_QUESTION_WISE_ANALYSIS_DATA_SUCCESS:
      let queWiseData = action.payload
      queWiseData = queWiseData.sort((a, b) => Number(a.order) - Number(b.order))
      return {
        ...state,
        questionWiseAnalysis: [...queWiseData]
      }
    case GET_QUESTION_WISE_ANALYSIS_DATA_FAIL:
      return {
        ...state,
        questionWiseAnalysis: []
      }

    //Get exit analysis 
    case GET_EXIT_ANALYSIS_DATA_REQUEST:
      return {
        ...state,
        exitAnalysis: []
      }
    case GET_EXIT_ANALYSIS_DATA_SUCCESS:
      let queExitData = action.payload
      queExitData = queExitData.sort((a, b) => Number(a.order) - Number(b.order))
      return {
        ...state,
        exitAnalysis: [...queExitData]
      }
    case GET_EXIT_ANALYSIS_DATA_FAIL:
      return {
        ...state,
        exitAnalysis: []
      }

    //Get leads data 
    case GET_LEADS_DATA_REQUEST:
      return {
        ...state,
        leadsData: []
      }
    case GET_LEADS_DATA_SUCCESS:
      return {
        ...state,
        leadsData: action.payload
      }
    case GET_LEADS_DATA_FAIL:
      return {
        ...state,
        leadsData: []
      }

    //Clear all data
    case CLEAR_GRAPH_DATA:
      return {
        ...state,
        completionData: {},
        questionWiseAnalysis: [],
        exitAnalysis: [],
        leadsData: [],
      }


    //Default
    default:
      return state;
  }
}

export { analyticsReducer }